import { Injectable } from "@angular/core"
import { AngularFirestoreDocument } from "@angular/fire/firestore"

import { GlobalPricingVariables } from "@tr/models"
import { FirebaseDocumentBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class GlobalPricingVariablesService extends FirebaseDocumentBase<GlobalPricingVariables> {
  constructor(private fb: FirebaseService) {
    super(fb)
  }

  public getDocument(): AngularFirestoreDocument<GlobalPricingVariables> {
    return this.fb
      .collection("globalVariables")
      .doc<GlobalPricingVariables>("pricingVariables")
  }

}
